// extracted by mini-css-extract-plugin
module.exports = {"emptyResult":"files_emptyResult_86eOl"};